export const DEV_CREDIT_STATS_OVERRIDE_STORAGE_KEY = 'dev-credit-stats-override';

export const DEV_CREDIT_STATS_OVERRIDE_CHANGED_EVENT = 'dev-credit-stats-override-changed';

export type DevCreditStatsOverride = 'depleted';

export const getDevCreditStatsOverride = (): DevCreditStatsOverride | null => {
  if (typeof window === 'undefined') {
    return null;
  }

  try {
    const value = localStorage.getItem(DEV_CREDIT_STATS_OVERRIDE_STORAGE_KEY);

    return value === 'depleted' ? 'depleted' : null;
  } catch {
    return null;
  }
};

export const setDevCreditStatsOverride = (override: DevCreditStatsOverride | null) => {
  if (typeof window === 'undefined') {
    return;
  }

  if (override === null) {
    localStorage.removeItem(DEV_CREDIT_STATS_OVERRIDE_STORAGE_KEY);
  } else {
    localStorage.setItem(DEV_CREDIT_STATS_OVERRIDE_STORAGE_KEY, override);
  }

  window.dispatchEvent(new CustomEvent(DEV_CREDIT_STATS_OVERRIDE_CHANGED_EVENT));
};

export const isDevCreditStatsDepletedOverrideActive = () => getDevCreditStatsOverride() === 'depleted';

export const subscribeToDevCreditStatsOverride = (onStoreChange: () => void) => {
  if (typeof window === 'undefined') {
    return () => {};
  }

  const handleStorageChange = (event: StorageEvent) => {
    if (event.key === DEV_CREDIT_STATS_OVERRIDE_STORAGE_KEY) {
      onStoreChange();
    }
  };

  window.addEventListener('storage', handleStorageChange);
  window.addEventListener(DEV_CREDIT_STATS_OVERRIDE_CHANGED_EVENT, onStoreChange);

  return () => {
    window.removeEventListener('storage', handleStorageChange);
    window.removeEventListener(DEV_CREDIT_STATS_OVERRIDE_CHANGED_EVENT, onStoreChange);
  };
};
